export default function Cart() {
  return <section data-section-id="2200" id="cart-content" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-16 md:top-24 -translate-x-1/2 select-none font-default font-bold text-foreground/5 leading-none" style={{
      fontSize: "clamp(12rem, 22vw, 22rem)"
    }}>
        01
      </div>

      <div className="relative mx-auto w-full max-w-[1440px] px-5 md:px-12 lg:px-[4.5rem]">
        {}
        <div className="relative mx-auto max-w-[880px] text-center">
          {}
          <div className="flex items-center justify-center gap-3 mb-8">
            <span aria-hidden="true" className="inline-block h-px w-6 bg-border" />
            <span className="font-mono text-[0.75rem] md:text-[0.8125rem] font-medium uppercase tracking-[0.18em] text-foreground">
              § N° 01 — Your Editorial Selection
            </span>
            <span aria-hidden="true" className="inline-block h-px w-6 bg-border" />
          </div>

          {}
          <h1 className="font-default font-bold text-foreground leading-[0.9] tracking-tighter" style={{
          fontSize: "clamp(2.75rem, 6.5vw, 6.25rem)"
        }}>
            Your{" "}
            <span className="italic relative inline-block">
              curated
            </span>{" "}
            edit.
          </h1>

          {}
          <div className="mt-10 flex items-center justify-center">
            <span aria-hidden="true" className="inline-block h-px w-32 md:w-48 bg-border" />
            <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-lg bg-accent -ml-px" />
          </div>

          <p className="mt-8 font-default text-muted-foreground text-base md:text-lg leading-relaxed max-w-[600px] mx-auto">
            Review your selected pieces below. Each item has been verified for quality — adjust your quantities or proceed to finalize your acquisition.
          </p>
        </div>

        {}
        <div className="mt-16 md:mt-24 relative">
          {}
          <div className="flex items-center mb-10">
            <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-lg bg-accent" />
            <span aria-hidden="true" className="flex-1 h-px bg-border" />
          </div>

          {}
          <div className="font-default text-foreground">
            <div dangerouslySetInnerHTML={{
            __html: '[woocommerce_cart]'
          }} />
          </div>

          {}
          <div className="flex items-center mt-10">
            <span aria-hidden="true" className="flex-1 h-px bg-border" />
            <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-lg bg-accent" />
          </div>
        </div>

        {}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-4 text-center">
          <span className="font-mono text-[0.6875rem] font-normal uppercase tracking-[0.08em] text-muted-foreground">
            Atelier · Lush Fashion · LSH-001
          </span>
          <span aria-hidden="true" className="hidden md:inline-block h-px w-6 bg-border" />
          <span className="font-mono text-[0.6875rem] font-normal uppercase tracking-[0.08em] text-muted-foreground">
            Premium Digital Boutique
          </span>
        </div>
      </div>
    </section>;
}